import { FC } from "react";

interface IconFilterProps {
  className?: string;
}

const IconFilter: FC<IconFilterProps> = ({ className }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_566_10832)">
        <path
          d="M11.879 5.32242C13.0084 5.32242 13.924 4.40684 13.924 3.27742C13.924 2.148 13.0084 1.23242 11.879 1.23242C10.7496 1.23242 9.83398 2.148 9.83398 3.27742C9.83398 4.40684 10.7496 5.32242 11.879 5.32242Z"
          stroke="#292D34"
          strokeWidth="1.5"
        />
        <path d="M9.83345 3.2774H1.93945M17.2235 3.2774H14.3675" stroke="#292D34" strokeWidth="1.5" />
        <path
          d="M7.45109 13.4318C6.32167 13.4318 5.40609 12.5162 5.40609 11.3868C5.40609 10.2574 6.32167 9.3418 7.45109 9.3418C8.58052 9.3418 9.49609 10.2574 9.49609 11.3868C9.49609 12.5162 8.58052 13.4318 7.45109 13.4318Z"
          stroke="#292D34"
          strokeWidth="1.5"
        />
        <path d="M9.49662 11.3868H17.3906M2.10662 11.3868H4.96262" stroke="#292D34" strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_566_10832">
          <rect width="18" height="14" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconFilter;
